import { Route, RouteObject } from "react-router-dom";
import ReconnectionLandingPage from "./components/landing/landing";
import { CreateReconnectionRequest } from "./components";
import ReconnectionReceipt from "./components/receipt/receipt";
import ReconnectionRequestDetailPage from "./components/details/details";
import ReconnectionSuccessPage from "./components/receipt/receipt";
import LandingReconnectRequest from "./components/create/landing";
import BulkReconnectionLanding from "./components/details/bulkReconnection/landing/landing";

export interface reconnectionRoute extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: reconnectionRoute[];
}

export const reconnectionRoutes: reconnectionRoute[] = [
  {
    path: "cx/reconnections",
    element: <ReconnectionLandingPage />,
  },
  {
    path: "cx/reconnections/create",
    element: <LandingReconnectRequest />,
  },
  {
    path: "cx/reconnections/create/:step",
    element: <LandingReconnectRequest />,
  },
  {
    path: "cx/reconnections/receipt",
    element: <ReconnectionReceipt />,
  },
  // {
  //   path: 'cx/reconnections/:id',
  //   element: <ReconnectionRequestDetailPage />,
  // },
  {
    path: "cx/reconnections/success",
    element: <ReconnectionSuccessPage />,
  },

  {
    path: "cx/reconnections/view/:action/:id",
    element: <ReconnectionRequestDetailPage />,
  },
  {
    path: "cx/reconnections/bulk/view/:action/:id",
    element: <BulkReconnectionLanding />,
  },
];
